import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

import Wrapper from '../../components/Wrapper';
import Header from '../../components/Header';
import Body from '../../components/Body';
import Footer from '../../components/Footer';
import TopBar from '../../components/TopBar';
import SubmitButton from '../../components/SubmitButton';

const fontDefault = {
  fontFamily: 'Prompt',
  fontStyle: 'normal'
};

const styles = {
  textTopBar: {
    ...fontDefault,
    color: 'white',
    fontSize: '18px'
  },
  title: {
    ...fontDefault,
    fontSize: '20px',
    color: '#4A4A4A',
    fontWeight: 500,
    marginTop: '15px'
  },
  titleContainer: {
    marginTop: '29px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  textFieldContainer: {
    marginLeft: '15px',
    marginRight: '15px',
    marginTop: '15px'
  },
  textField: {
    ...fontDefault,
    color: '#4B5161'
  },
  detail: {
    ...fontDefault,
    fontSize: '12px',
    color: '#878B96',
    marginTop: '8px',
    marginBottom: '0px',
    marginLeft: '15px',
    marginRight: '15px'
  }
};

const CustomTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#F78E02'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#F78E02'
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#F78E02'
      }
    }
  }
})(TextField);

class EnterEmail extends Component {
  goToNextPage = () => {
    const {
      history: { push }
    } = this.props;
    push('/summary');
  };

  backButton = () => {
    const {
      history: { push }
    } = this.props;
    push('/personal-info');
  };

  render() {
    const { classes } = this.props;
    return (
      <Wrapper>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              การจัดส่งกรมธรรม์
            </Typography>
          </TopBar>
        </Header>
        <Body>
          <div className={classes.container}>
            <Grid container>
              <Grid container justify="center">
                <div className={classes.titleContainer}>
                  <svg
                    width="61"
                    height="40"
                    viewBox="0 0 61 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M60.0459 1.16133C60.0474 1.15234 60.0493 1.14334 60.0512 1.13435C60.0544 1.11934 60.0576 1.10434 60.0589 1.08933C60.0659 1.01533 60.0579 0.940335 60.0489 0.865335C60.048 0.856696 60.0481 0.848264 60.0482 0.839851C60.0484 0.82976 60.0485 0.819696 60.0469 0.809335C60.0289 0.710335 59.9959 0.613335 59.9469 0.520335C59.9422 0.511059 59.9366 0.50212 59.9309 0.493127C59.9268 0.486607 59.9227 0.480059 59.9189 0.473335C59.9175 0.471954 59.9171 0.470096 59.9166 0.468091L59.9159 0.465335C59.9155 0.46449 59.9147 0.463824 59.9138 0.463111C59.9127 0.462134 59.9115 0.461068 59.9109 0.459335C59.9079 0.454699 59.9052 0.449887 59.9024 0.445121L59.9024 0.445075C59.8986 0.438546 59.8949 0.432107 59.8909 0.426335C59.8289 0.335335 59.7539 0.260335 59.6699 0.196335C59.6593 0.188553 59.6478 0.182625 59.6363 0.176662L59.6363 0.176649C59.627 0.171888 59.6178 0.167104 59.6089 0.161335C59.5349 0.112335 59.4569 0.0723347 59.3729 0.0453347C59.3403 0.034777 59.3078 0.0288637 59.2745 0.0228276L59.2609 0.0203347C59.1879 0.00533472 59.1149 -0.00166528 59.0389 0.000334718C58.9989 0.00133472 58.9609 0.00333472 58.9209 0.00933472C58.9093 0.0111121 58.898 0.0113099 58.8866 0.0115074C58.8725 0.0117544 58.8583 0.0120007 58.8439 0.0153347L0.797885 12.0113C0.384885 12.0973 0.068885 12.4323 0.00988495 12.8503C-0.049115 13.2683 0.159885 13.6783 0.532885 13.8753L17.1649 22.6483L20.0819 38.8353C20.0808 38.842 20.0812 38.849 20.0816 38.8559L20.0821 38.8645C20.0821 38.8672 20.0821 38.8698 20.0819 38.8723C20.0719 38.9523 20.0709 39.0303 20.0809 39.1093C20.0859 39.1493 20.0909 39.1873 20.1009 39.2263C20.1239 39.3213 20.1609 39.4103 20.2109 39.4943C20.2157 39.502 20.2182 39.5103 20.2207 39.5187C20.2234 39.5278 20.2261 39.537 20.2319 39.5453C20.2341 39.5491 20.2375 39.5523 20.2408 39.5554L20.2439 39.5583C20.2512 39.5691 20.2601 39.5785 20.2692 39.5881C20.2762 39.5955 20.2833 39.6031 20.2899 39.6113C20.3369 39.6693 20.3859 39.7223 20.4419 39.7673C20.4438 39.7688 20.4456 39.7705 20.4473 39.7723C20.4484 39.7734 20.4495 39.7746 20.4505 39.7758C20.4514 39.7768 20.4523 39.7778 20.4532 39.7789C20.4573 39.7837 20.4615 39.7886 20.4669 39.7923C20.4748 39.7982 20.4833 39.8017 20.4918 39.8053L20.4918 39.8053C20.4993 39.8085 20.5068 39.8116 20.5139 39.8163C20.5749 39.8563 20.6379 39.8893 20.7049 39.9153C20.7143 39.9188 20.7236 39.9226 20.7327 39.9263C20.7498 39.9333 20.7667 39.9401 20.7849 39.9453C20.8749 39.9713 20.9679 39.9893 21.0619 39.9893H21.0649C21.0669 39.9893 21.0689 39.9888 21.0709 39.9883C21.0729 39.9878 21.0749 39.9873 21.0769 39.9873C21.0939 39.9883 21.1109 39.9893 21.1279 39.9893C21.4049 39.9893 21.6549 39.8653 21.8399 39.6743L32.9189 32.2883L44.5189 39.8283C44.6829 39.9343 44.8729 39.9893 45.0639 39.9893C45.1689 39.9893 45.2759 39.9723 45.3789 39.9383C45.6669 39.8423 45.8969 39.6203 46.0019 39.3343L59.9979 1.34533C60.0109 1.31133 60.0219 1.27633 60.0309 1.24033C60.0332 1.23159 60.0345 1.22285 60.0358 1.21431C60.0367 1.20819 60.0376 1.20218 60.0389 1.19633C60.0419 1.18533 60.0439 1.17333 60.0459 1.16133ZM48.4639 7.54433L24.4709 25.1853C24.4417 25.2071 24.4169 25.2327 24.392 25.2586C24.3837 25.2672 24.3754 25.2758 24.3669 25.2843L24.3554 25.2946C24.3464 25.3025 24.3376 25.3102 24.3299 25.3193C24.3089 25.3423 24.2899 25.3653 24.2709 25.3903C24.2583 25.4071 24.2477 25.4243 24.237 25.4417L24.2245 25.4618L24.2229 25.4643C24.1859 25.5243 24.1549 25.5863 24.1309 25.6523C24.13 25.6547 24.129 25.6569 24.1279 25.6591C24.1263 25.6624 24.1246 25.6655 24.1229 25.6686L24.1229 25.6687C24.1203 25.6735 24.1177 25.6783 24.1156 25.6835L24.1139 25.6883C24.1134 25.6903 24.1121 25.6918 24.1109 25.6933L24.1095 25.695C24.1088 25.696 24.1082 25.6971 24.1079 25.6983L21.3579 34.6353L19.1789 22.5443L48.4639 7.54433ZM25.6339 27.5553L22.9079 36.5593L26.9679 33.8523L31.0919 31.1033L29.8779 30.3143L25.6339 27.5553ZM52.0439 3.46333L18.0709 20.8643L3.93088 13.4063L52.0439 3.46333ZM29.1539 27.4573L44.5589 37.4693L56.9749 3.76833L26.8209 25.9403L29.1539 27.4573Z"
                      fill="#878B96"
                    />
                  </svg>
                  <span className={classes.title}>
                    อีเมลสำหรับจัดส่งกรมธรรม์
                  </span>
                </div>
              </Grid>

              <Grid item xs={12}>
                <div className={classes.textFieldContainer}>
                  <CustomTextField
                    id="standard-bare"
                    fullWidth
                    placeholder="อีเมล"
                    className={classes.textField}
                    margin="normal"
                    variant="outlined"
                    inputProps={{ 'aria-label': 'bare' }}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <p className={classes.detail}>
                  ต้องการกรมธรรม์ทางไปรษณีย์สามารถแจ้งการจัดส่งเพิ่มเติมได้ที่ 0
                  2111 1111
                </p>
              </Grid>
            </Grid>
          </div>
        </Body>
        <Footer>
          <SubmitButton onClick={this.goToNextPage}>ต่อไป</SubmitButton>
        </Footer>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EnterEmail));
